const object = vnObject;

document.addEventListener('DOMContentLoaded', function () {

  const DESKTOP_BREAKPOINT = 992;

  const menuParents = document.querySelectorAll('.js-menu-parent');
  const toggleButton = document.querySelector('.js-menu-toggle');
  const mobileMenu = document.querySelector('.js-mobile-menu');
  const header = document.querySelector('.js-header');
  const body = document.body;

  if (!toggleButton || !mobileMenu || !header) return;

  const label = toggleButton.querySelector('.vn-a-content');
  const icon = toggleButton.querySelector('.vn-a-icon i');

  /*
  -------------------------------------------------
  Gestion des sous-menus (desktop / mobile)
  -------------------------------------------------
  */

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  /*menuParents.forEach(function (parent) {

    const submenu = parent.querySelector('.js-submenu');
    if (!submenu) return;

    let timeout;

    // HOVER DESKTOP
    parent.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;

      clearTimeout(timeout);
      submenu.classList.add('is-open');
    });

    parent.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;

      timeout = setTimeout(function () {
        submenu.classList.remove('is-open');
      }, 150);
    });

    // CLICK MOBILE
    parent.addEventListener('click', function (e) {
      if (isDesktop()) return;

      const parentLink = parent.querySelector(':scope > a');
      const clickedInsideSubmenu = e.target.closest('.js-submenu');

      // Si on clique dans le sous-menu → on laisse naviguer
      if (clickedInsideSubmenu) return;

      // Si on clique sur le lien parent (ou un de ses enfants)
      if (parentLink && e.target.closest('a') === parentLink) {
        e.preventDefault();

        // Ferme les autres sous-menus
        menuParents.forEach(function (otherParent) {
          if (otherParent !== parent) {
            const otherSub = otherParent.querySelector('.js-submenu');
            if (otherSub) otherSub.classList.remove('is-open');
          }
        });

        submenu.classList.toggle('is-open');
      }
    });

  });*/

    menuParents.forEach(function (parent) {

        const submenu = parent.querySelector('.js-submenu');
        const button  = parent.querySelector('.item__button');
        if (!submenu || !button) return;

        let closeTimer;

        function scheduleClose() {
            clearTimeout(closeTimer);
            closeTimer = setTimeout(function () {
                if (!button.matches(':hover') && !submenu.matches(':hover')) {
                    submenu.classList.remove('is-open');
                }
            }, 80);
        }

        // HOVER DESKTOP — bindé sur le bouton + le submenu, PAS le <li>
        button.addEventListener('mouseenter', function () {
            if (!isDesktop()) return;
            clearTimeout(closeTimer);
            submenu.classList.add('is-open');
        });

        button.addEventListener('mouseleave', function () {
            if (!isDesktop()) return;
            scheduleClose();
        });

        submenu.addEventListener('mouseenter', function () {
            if (!isDesktop()) return;
            clearTimeout(closeTimer);
        });

        submenu.addEventListener('mouseleave', function () {
            if (!isDesktop()) return;
            scheduleClose();
        });

        // CLICK MOBILE (inchangé)
        parent.addEventListener('click', function (e) {
            if (isDesktop()) return;

            const parentLink = parent.querySelector(':scope > a');
            const clickedInsideSubmenu = e.target.closest('.js-submenu');

            if (clickedInsideSubmenu) return;

            if (parentLink && e.target.closest('a') === parentLink) {
                e.preventDefault();

                menuParents.forEach(function (otherParent) {
                    if (otherParent !== parent) {
                        const otherSub = otherParent.querySelector('.js-submenu');
                        if (otherSub) otherSub.classList.remove('is-open');
                    }
                });

                submenu.classList.toggle('is-open');
            }
        });
    });

    /*
    -------------------------------------------------
    Gestion du menu mobile principal
    -------------------------------------------------
    */

  toggleButton.addEventListener('click', function () {

    // Si un sous-menu mobile est ouvert → on le ferme uniquement
    if (!isDesktop()) {
      const openedSubmenu = mobileMenu.querySelector('.js-submenu.is-open');
      if (openedSubmenu) {
        openedSubmenu.classList.remove('is-open');
        return; // on stop ici
      }
    }

    const isOpen = mobileMenu.classList.toggle('is-open');
    header.classList.toggle('mobile-menu-open');
    body.classList.toggle('no-scroll', isOpen);

    toggleButton.setAttribute('aria-expanded', isOpen);

    if (label) {
      label.textContent = isOpen ? object.close : object.menu;
    }

    if (icon) {
      icon.className = isOpen
          ? 'vn-icons vn-icons-close'
          : 'vn-icons vn-icons-menu';
    }

  });

  function updateNavbarHeight() {
    const header = document.querySelector('.js-header-container');
    const height = header ? header.offsetHeight : 0;

    document.body.style.setProperty('--navbar-height', `${height}px`);
  }

  window.addEventListener('load', updateNavbarHeight);
  window.addEventListener('resize', updateNavbarHeight);
});
